/*
 * Licensed Materials - Property of IBM
 *
 * PID 5725-H26
 *
 * Copyright IBM Corporation 2026. All Rights Reserved.
 *
 * US Government Users Restricted Rights - Use, duplication or disclosure
 * restricted by GSA ADP Schedule Contract with IBM Corp.
 */

import { ReduxUtils } from '@spm/core';

import { POST_SD_CREATE_USER } from './actionTypes';

import { postSdCreateUserUtil } from './utils';

/**
 * Contains the action creator functions that update the SDSignup slice of the store.
 *
 * @namespace SDSignupActions
 */
export default class actions {
  /**
   * Calls the api and dispatches the results to the store.
   * api: /v1/sd_create_user
   *
   * @param {NewSDUAUserAccount} data object that will be posted to the api
   * @param {function} callback function to call once this function has finished
   * @function
   * @memberof SDSignupActions
   */
  static postSdCreateUser = (dispatch, newSDUAUserAccount, callback) => {
    ReduxUtils.generateAction(
      dispatch,
      postSdCreateUserUtil.bind(null, newSDUAUserAccount),
      POST_SD_CREATE_USER,
      callback
    );
  };

  /**
   * Dispatches the data to the store to reset the data cached from a call to postSdCreateUser.
   *
   * @param {function} dispatch
   * @param {Object} data object to be set in the store.
   * @function
   * @memberof SDSignupActions
   */
  static resetPostSdCreateUser = (dispatch, data) => {
    const json = {
      type: POST_SD_CREATE_USER.successAction,
      payload: data,
    };
    dispatch(json);
  };

  /**
   * Dispatches the data to the store to reset the error cached from a call to postSdCreateUser.
   *
   * @param {function} dispatch
   * @function
   * @memberof SDSignupActions
   */
  static resetPostSdCreateUserError = dispatch => {
    ReduxUtils.resetErrorAction(dispatch, POST_SD_CREATE_USER.failureAction);
  };
}
